<template>
    <div id="v-sidenav" class="scrollbar">
        <div class="sidenav-content" ref="sidenavContent">
            <v-treeview
                v-if="reloadSideNav"
                v-model="selection"
                :items="globalMainMenu"
                shaped
                hoverable
                activatable
                item-key="fileId"
                @update:active="get_category_data"
                @update:open="open_menu_tree"
                ref="sideNavTree"
            >
                <template v-slot:prepend="{ item, open }">
                    <v-icon v-if="!item.file">
                        {{ open ? "mdi-folder-open" : "mdi-folder" }}
                    </v-icon>
                </template>
                <template v-slot:append="{ item }">
                    <v-tooltip right v-if="item.tooltip">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                class="alert-icon-btn"
                                dark
                                :ripple="false"
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon class="alert-icon"
                                    >mdi-information</v-icon
                                >
                            </v-btn>
                        </template>

                        <span v-if="item.tooltip">{{ item.tooltip }}</span>
                    </v-tooltip>
                </template>
            </v-treeview>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState, mapMutations } from "vuex";
import { timeout } from "@/utils/util";
export default {
    name: "v-sidenav",
    props: {
        data: {
            type: Object,
            required: false,
        },
    },
    data() {
        return {
            selection: [],
            currentFolderIds: null,
        };
    },
    watch: {
        resetSideNav(newData) {
            this.selection = [];
            this.currentFolderIds = null;
            this.updateOpenSideNav({ show: false, reset: true });
            this.$refs.sideNavTree && this.$refs.sideNavTree.updateAll(false);
            //  清除文件夹ID
            this.$store.state.search.searchCondition.folderIds = null;
            $(".v-treeview-node__root").removeClass(
                "v-treeview-node--active primary--text"
            );
        },
        async triggerSideNavShow(newData) {
            if (newData) {
                await timeout(400);
                $(this.$refs.sidenavContent).fadeIn(120);
            } else {
                $(this.$refs.sidenavContent).fadeOut();
            }
        },
    },

    computed: {
        ...mapState("triggerEvtents", ["resetSideNav"]),
        ...mapState("mixins", ["triggerSideNavShow", "reloadSideNav"]),
        ...mapState("global", ["isNewBeveliver"]),
        ...mapGetters("global", ["globalMainMenu"]),
    },
    components: {},
    created() {},
    mounted() {
        this.current_item_highlight();
    },
    beforeDestroy() {},
    methods: {
        ...mapMutations("triggerEvtents", [
            "updateInitSearchCondition",
            "updateGetSchemaData",
            "updateSnackbar",
        ]),
        ...mapMutations("search", ["updateSearchCondition"]),
        ...mapMutations("mixins", ["updateOpenSideNav"]),

        //  侧边栏数据
        async get_category_data(folderIds) {
            if (!folderIds.length || this.currentFolderIds === folderIds[0]) {
                return;
            }

            this.currentFolderIds = folderIds[0];
            //  如果用户在收藏页或收藏详情页
            this.$P.returnIndex(this);
            this.updateInitSearchCondition();
            this.$P.schemaType = "basicData";
            this.updateSearchCondition({ folderIds });
            this.updateGetSchemaData();
        },

        current_item_highlight() {
            $(".v-treeview").on(
                "click",
                ".v-treeview-node__root",
                async (ev) => {
                    ev.stopPropagation();
                    $(".v-treeview-node__root").removeClass(
                        "v-treeview-node--active primary--text"
                    );

                    $(ev.currentTarget).addClass(
                        "v-treeview-node--active primary--text"
                    );
                }
            );
        },
        //  用来触发展开侧边栏时执行Goolge 翻译
        async open_menu_tree() {
            if (!this.isNewBeveliver) return;
            await timeout(150);
            if ($("#translationStatement").length) {
                $("#translationStatement").remove();
            } else {
                $("body").append(
                    `<div id="translationStatement">Translation of this website is provided by Google Translate</div>`
                );
            }
        },
    },
};
</script>

<style lang="scss">
#v-sidenav {
    position: fixed;
    top: 64px;
    left: 0;
    z-index: 999;
    width: 260px;
    height: calc(100vh - 60px);
    border-right: 1px solid #e2e4f8;
    background-color: $color-white;
    overflow: hidden;
    overflow-y: auto;
    padding-top: 8px;

    .v-treeview {
        padding-bottom: 30px;
    }

    .v-treeview-node__root {
        margin: 2px 0;
        min-height: 36px;

        .v-treeview-node__content {
            align-items: flex-start;
            padding: 4px 0;
            cursor: pointer;

            &:hover {
                .v-treeview-node__append {
                    animation-name: displayFadeIn;

                    * {
                        display: block;
                    }
                }
            }

            .v-treeview-node__label {
                font-size: 14px;
                padding-top: 4px;
                overflow: unset;
                text-overflow: unset;
                white-space: unset;
            }

            .v-treeview-node__append {
                margin: auto 0;
                width: 16px;
                min-width: 16px;

                opacity: 0;
                visibility: hidden;
                animation-duration: 0.2s;
                animation-delay: 0.14s;
                animation-fill-mode: forwards;

                * {
                    display: none;
                }
            }
        }

        .v-treeview-node__toggle {
            width: 22px;
            height: 22px;
            position: relative;

            &::after {
                transform: unset;
            }
        }

        .v-treeview-node__content {
            margin-left: 0px;

            .v-treeview-node__prepend {
                min-width: 22px;
                margin-right: 4px;

                .v-icon {
                    font-size: 22px;
                }
            }
        }
    }
}

.alert-icon-btn {
    width: 16px;
    height: 16px;

    .alert-icon {
        font-size: 16px !important;
        color: #2878e5 !important;
        opacity: 0.6;
    }
}

.v-tooltip__content.v-tooltip__content--fixed {
    background: rgba(#50535a, 0.9);

    &::before {
        content: "";
        display: block;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 7px 6px 7px 0;
        border-color: transparent rgba(#50535a, 0.9) transparent transparent;
        position: absolute;
        left: -6px;
        top: 0;
        bottom: 0;
        margin: auto;
    }
    span {
        font-size: 12px;
    }
}

.slide-left-leave-active,
.slide-left-enter-active {
    animation-duration: 0.35s;
    transition-timing-function: cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-left-enter {
    visibility: hidden;
}

.slide-left-enter-to {
    animation-name: slideInLeft;
}

.slide-left-leave-to {
    animation-name: slideOutLeft;
}

#translationStatement {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 20px;
    margin: auto;
    z-index: 1200;
    width: 400px;
    text-align: center;
    color: $color-white;
    background-color: #1f1f1f;
    border-radius: 4px;
    line-height: 1.3em;
    font-size: 16px;
    padding: 8px;
    opacity: 0;
    pointer-events: none;
}

@keyframes slideInLeft {
    from {
        transform: translate3d(-105%, 0, 0);
        visibility: hidden;
    }

    to {
        transform: translate3d(0, 0, 0);
        visibility: visible;
    }
}

@keyframes slideOutLeft {
    from {
        transform: translate3d(0, 0, 0);
    }

    to {
        visibility: hidden;
        transform: translate3d(-105%, 0, 0);
    }
}

@keyframes displayFadeIn {
    from {
        opacity: 0;
        visibility: hidden;
    }

    to {
        opacity: 1;
        visibility: visible;
    }
}
</style>
